export interface FightItem { level: string; num: number }
export const MAX_FIGHTS = 7
const DEFAULT_FIGHTS: FightItem[] = [
  {level:"jm",num:1}, {level:"hd",num:99}, {level:"ce",num:99},
  {level:"ls",num:99}, {level:"1-7",num:99},
]
export function initializeFightPlan(plan?: FightItem[] | null): FightItem[] {
  return (plan ?? DEFAULT_FIGHTS).map(item => ({...item}))
}
export function addFight(plan: FightItem[]): FightItem[] {
  return plan.length >= MAX_FIGHTS ? plan : [...plan, {level:"",num:1}]
}
export function moveFight(plan: FightItem[], index: number, direction: number): FightItem[] {
  const target = index + direction
  if (index < 0 || index >= plan.length || target < 0 || target >= plan.length) return plan
  const next = [...plan]
  ;[next[index], next[target]] = [next[target], next[index]]
  return next
}
export function validateFightPlan(plan: FightItem[]): string | null {
  if (plan.length > MAX_FIGHTS) return "最多设置 7 项作战。原有配置未被截断，请手动调整后保存。"
  for (let i = 0; i < plan.length; i++) {
    if (!plan[i].level.trim()) return `请填写第 ${i + 1} 项作战的关卡`
    if (!Number.isInteger(plan[i].num) || plan[i].num < 1 || plan[i].num > 99) return `第 ${i + 1} 项作战次数须为 1–99 的整数`
  }
  return null
}
